const academyRouterPaths = {
  root: '/academy',
};

export default academyRouterPaths;
